import { render, staticRenderFns } from "./teacher.vue?vue&type=template&id=d64620f2&scoped=true"
import script from "./teacher.vue?vue&type=script&lang=js"
export * from "./teacher.vue?vue&type=script&lang=js"
import style0 from "./teacher.vue?vue&type=style&index=0&id=d64620f2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64620f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d64620f2')) {
      api.createRecord('d64620f2', component.options)
    } else {
      api.reload('d64620f2', component.options)
    }
    module.hot.accept("./teacher.vue?vue&type=template&id=d64620f2&scoped=true", function () {
      api.rerender('d64620f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/teacher.vue"
export default component.exports